var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 17.6667H11.25C10.8358 17.6667 10.5 18.0398 10.5 18.5C10.5 18.9602 10.8358 19.3333 11.25 19.3333H12.75C13.1642 19.3333 13.5 18.9602 13.5 18.5C13.5 18.0398 13.1642 17.6667 12.75 17.6667ZM11.25 16C10.0074 16 9 17.1193 9 18.5C9 19.8807 10.0074 21 11.25 21H12.75C13.9926 21 15 19.8807 15 18.5C15 17.1193 13.9926 16 12.75 16H11.25Z",
    fill: "#CACCD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6429 11.3333H9.35714C8.9232 11.3333 8.57143 11.6318 8.57143 12C8.57143 12.3682 8.9232 12.6667 9.35714 12.6667H15.6429C16.0768 12.6667 16.4286 12.3682 16.4286 12C16.4286 11.6318 16.0768 11.3333 15.6429 11.3333ZM9.35714 10C8.05533 10 7 10.8954 7 12C7 13.1046 8.05533 14 9.35714 14H15.6429C16.9447 14 18 13.1046 18 12C18 10.8954 16.9447 10 15.6429 10H9.35714Z",
    fill: "#CACCD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6 4.66667H6.4C5.95817 4.66667 5.6 5.03976 5.6 5.5C5.6 5.96024 5.95817 6.33333 6.4 6.33333H17.6C18.0418 6.33333 18.4 5.96024 18.4 5.5C18.4 5.03976 18.0418 4.66667 17.6 4.66667ZM6.4 3C5.07452 3 4 4.11929 4 5.5C4 6.88071 5.07452 8 6.4 8H17.6C18.9255 8 20 6.88071 20 5.5C20 4.11929 18.9255 3 17.6 3H6.4Z",
    fill: "#CACCD1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.9ab113cc.svg";
export { ForwardRef as ReactComponent };